import { HtmlPagesListAdminView } from "htmlpage/admin/views/HTMLPagesListAdminView";
import { Route, Routes } from "react-router-dom";
import { HtmlPageAdminView } from "htmlpage/admin/views/HTMLPageAdminView";
export function HtmlPageAdminRoutes() {
  return (
    <Routes>
      <Route path="" element={<HtmlPagesListAdminView />} />
      <Route path="new" element={<HtmlPageAdminView isCreateMode={true} />} />
      <Route path=":htmlPageId">
        <Route path="" element={<HtmlPageAdminView isCreateMode={false} />} />
      </Route>
      <Route path=":htmlPageId/duplicate">
        <Route path="" element={<HtmlPageAdminView isCreateMode={false} />} />
      </Route>
    </Routes>
  );
}
//build fix
